<template>
  <div>
    <div class="news_div__class" id="newsCard">
      <div
        class="news_content__class width_20_class"
        @click="routeToNewDetailPage(item)"
      >
        <avatar-or-initials
          :image="item.image_url"
          size="50"
        ></avatar-or-initials>
      </div>
      <div class="news_content__class">
        <div class="news__class" @click="routeToNewDetailPage(item)">
          {{ item.title }}
        </div>
        <div class="d-flex width_100__class">
          <div class="news_other_detail__class">
            {{ item.source }} | {{ item.time }} ago
          </div>
          <v-spacer></v-spacer>
          <v-icon small color="#535353" @click="shareLink('newsCard')"
            >mdi-share-variant-outline</v-icon
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ROUTER_URL from "@/constant/urls";
import helper from "@/helper/index.js";
export default {
  name: "NewsCard",
  components: {
    AvatarOrInitials: () => import("@/components/AvatarOrInitials.vue"),
  },
  props: {
    item: {
      type: Object,
    },
    security: {
      type: Object,
    },
  },
  data() {
    return {
      //   router_url: ROUTER_URL,
    };
  },
  computed: {},
  watch: {},
  methods: {
    shareLink(refValue) {
      let url = location.href;
      let text = `Hey check out ${this.security.symbol} stock on Covesto Social Trading Platform.`;
      let title = "Stock Detail";
      helper.shareSsAndLink(refValue, url, text, title);
    },
    routeToNewDetailPage(item) {
      const { id } = item;
      let query = this.$route.params.query;
      this.$router.push({
        name: ROUTER_URL.userPanel.children.newsDetail.name,
        query: { id: id, query: query },
      });
    },
  },
  mounted() {},
};
</script>
<style scoped>
.news_div__class {
  background: #fafafa;
  border: 1px solid rgba(0, 0, 0, 0.04);
  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.01);
  border-radius: 8px;
  padding: 10px;
  display: flex;
  width: 100%;
}
.news_content__class {
  margin: 5px;
  cursor: pointer;
}
.width_100__class {
  width: 100%;
}
.width_20_class {
  width: 10%;
}
.news__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 23px;
  /* or 153% */
  align-items: center;

  color: #454545;
}
.news_other_detail__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 15px;
  /* identical to box height */

  display: flex;
  align-items: center;

  color: #878787;
}
@media only screen and (max-width: 600px) {
  .width_20_class {
    width: 20%;
  }
}
</style>
